module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/5.95ecef42.png";